var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9311 10.6019L23.29 13.0236L24 12.3259L12 0L0 12.3257L0.716177 13.0236L3.08282 10.5926L4.01079 23.5523C4.02953 23.8139 4.24723 24 4.50952 24H19.5108C19.7732 24 19.9909 23.8138 20.0095 23.552L20.9311 10.6019ZM19.9963 9.64222L12 1.43311L4.01697 9.63311L4.99998 23H19L19.9963 9.64222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.3ef04be7abe9bae23534d58f13864b1b.svg";
export { ForwardRef as ReactComponent };